import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LibSpinnerV2Component } from './lib-spinner-v2.component';
@NgModule({
  declarations: [LibSpinnerV2Component],
  imports: [CommonModule],
  exports: [LibSpinnerV2Component],
})
export class LibSpinnerV2Module {}
